"use client";

import { Image } from "@nextui-org/react";

export function CarouselLeftArrow({ onClick }) {
    return (
        <button
            onClick={onClick}
            className="absolute left-4 -scale-x-100 cursor-pointer"
        >
            <Image
                src="/images/images-accueil/1.png"
                width={50}
                height={50}
                alt="Flèche gauche"

            />
        </button>
    )
}
